import { getQuarterLabel } from '@zet/utils/stringConversion'
import { map } from 'lodash'

import { bridgeApi } from '../network'
import {
  IMyTeamsEarningsList,
  IMyTeamsEarningsTotal,
  IPayoutEarnings,
  ITdsReports,
  MyTeamsEarningsProps,
  MyTeamsFiltersList,
  TdsReport,
} from './types'

export async function fetchMyTeamsTotalEarnings() {
  const { data } = await bridgeApi.get<IMyTeamsEarningsTotal>(
    '/api/v1/sub-agents/me/earnings',
    {
      params: {
        totalAmount: true,
      },
    }
  )
  return data.data
}

export async function fetchMyTeamsEarnings({
  filters,
  pagination,
}: MyTeamsEarningsProps) {
  const { data } = await bridgeApi.get<IMyTeamsEarningsList>(
    '/api/v1/sub-agents/me/earnings',
    {
      params: {
        limit: pagination.limit,
        offset: pagination.offset,
        totalAmount: false,
        filters: JSON.stringify(filters),
      },
    }
  )
  return {
    ...data.data,
    nextOffset: isNaN(Number(pagination?.offset)) ? 0 : pagination.offset + 10,
  }
}

export async function fetchMyTeamsEarningsFilters() {
  const { data } = await bridgeApi.get<MyTeamsFiltersList>(
    '/api/v1/sub-agents/me/earnings/filters'
  )
  return data.data
}

export async function getTdsReports(year: string) {
  const { data } = await bridgeApi.get<ITdsReports>(
    `api/report/tds/v2?year=${year}`
  )
  if (data?.data) {
    return {
      ...data?.data,
      reports: map(data?.data?.reports, (r: TdsReport) => {
        return {
          ...r,
          label: getQuarterLabel(r?.quarter, year),
        }
      }),
    }
  }
  return data?.data
}

export async function showPayoutEarnings() {
  const { data } = await bridgeApi.get<IPayoutEarnings>(
    '/api/v1/sub-agents/me/payout-plan/experiment/status'
  )
  return data.data
}
